import axios from '../axios/axiosConfig';
import { getGeneralProjectTotalPages } from '../redux/api/generalProjectPagination';
import { engineeringGroup, projectValue } from './engineeringTimeOverviewUtils';

export async function fetchEngineeringSchedule(endpoint, signal) {
  const projects = new Map();
  let totalPages = 1;
  for (let page = 1; page <= totalPages; page += 1) {
    const { data: payload } = await axios.get(endpoint, {
      params: { page, projectStatusNotEqual: 'Shipped' }, signal,
    });
    totalPages = Math.max(totalPages, getGeneralProjectTotalPages(payload?.pagination ?? payload?.Pagination ?? payload));
    const data = payload?.data ?? payload?.Data ?? payload;
    const entries = Array.isArray(data) ? data : data?.GeneralProjectInfo || data?.generalProjectInfo ? [data] : data && typeof data === 'object' ? Object.values(data) : null;
    if (!entries) throw new Error('Unexpected full-schedule response.');
    for (const entry of entries) {
      const project = entry?.GeneralProjectInfo ?? entry?.generalProjectInfo;
      if (!project || projectValue(project, 'ID') == null) throw new Error('Schedule record is missing GeneralProjectInfo or ID.');
      projects.set(String(projectValue(project, 'ID')), project);
    }
  }
  return [...projects.values()];
}

// Schedule dates take precedence, including cleared/omitted dates. Keep allocations
// from general-project when the schedule omits them.
export function mergeEngineeringSchedule(projects, schedule) {
  const byId = new Map(projects.map(project => [String(projectValue(project, 'ID')), project]));
  const merged = new Map([...byId].filter(([, project]) => engineeringGroup(project) === 'shipped'));
  for (const project of schedule) {
    const id = String(projectValue(project, 'ID'));
    const normalized = Object.fromEntries(Object.entries(project).map(([key, value]) => [key === 'id' ? 'ID' : key[0].toUpperCase() + key.slice(1), value]));
    const dates = {};
    ['MechanicalDue', 'ElectricalDue', 'ControlsDue', 'EngineeringDue', 'MechanicalDone', 'ElectricalDone', 'ControlsDone', 'EngineeringDone'].forEach(key => { dates[key] = projectValue(project, key) ?? ''; });
    merged.set(id, { ...byId.get(id), ...normalized, ...dates });
  }
  return [...merged.values()];
}
